import React from 'react';
import { Box, Container, Stack, Typography, Link, IconButton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const brand = {
    primary: '#800b33',
    dark: '#5c0620',
    slate: '#1d1320',
};

const Footer = () => (
    <Box component="footer" sx={{ py: 4, mt: 'auto', width: '100%', borderTop: '1px solid rgba(0,0,0,0.06)', bgcolor: '#fff' }}>
        <Container maxWidth="lg">
            <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems="center" spacing={2}>
                <Typography variant="body2" sx={{ color: '#6b6470' }}>© {new Date().getFullYear()} Savvy Community</Typography>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} alignItems="center">
                    <Link
                        component={RouterLink}
                        to="/privacy"
                        underline="hover"
                        sx={{
                            color: brand.slate,
                            fontSize: '0.9rem',
                            '&:hover': { color: brand.primary },
                        }}
                    >
                        Privacy
                    </Link>
                    <Link
                        component={RouterLink}
                        to="/terms"
                        underline="hover"
                        sx={{
                            color: brand.slate,
                            fontSize: '0.9rem',
                            '&:hover': { color: brand.primary },
                        }}
                    >
                        Terms
                    </Link>
                    <Link
                        component={RouterLink}
                        to="/account-deletion"
                        underline="hover"
                        sx={{
                            color: brand.slate,
                            fontSize: '0.9rem',
                            '&:hover': { color: brand.primary },
                        }}
                    >
                        Account Deletion
                    </Link>
                    <Stack direction="row" spacing={1}>
                        <Link href="https://play.google.com/store/apps/details?id=com.savvycommunity" target="_blank" rel="noreferrer">
                            <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" style={{ height: 32 }} />
                        </Link>
                        <Link href="https://apps.apple.com/app/savvy-community/id123456789" target="_blank" rel="noreferrer">
                            <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="App Store" style={{ height: 32 }} />
                        </Link>
                    </Stack>
                </Stack>
            </Stack>
        </Container>
    </Box>
);

export default Footer;
